import React from 'react';
import SendGridLink from '../../SendGridLink';
import { StyledCTA } from './styles';
import ExpertServicesSVG from '../../../assets/svg/cta/expert-services.svg';

const LookingForMoreCTA = () => (
  <StyledCTA>
    <figure>
      <ExpertServicesSVG />
    </figure>
    <div>
      <h4>Looking for more info?</h4>
      <p>Free to get started. Free to send.</p>
    </div>
    <div>
      <SendGridLink to="/contact-us-form/" className="btn btn--reversed">
        Talk to an expert
      </SendGridLink>
    </div>
  </StyledCTA>
);

export default LookingForMoreCTA;
